// Small display helpers shared by the wish cards (group Wishes tab + My Wishes).

export function formatPrice(min, max) {
    const f = (v) => `$${Number(v).toFixed(2)}`;
    if (min && max) return `${f(min)} – ${f(max)}`;
    if (min) return `From ${f(min)}`;
    if (max) return `Up to ${f(max)}`;
    return null;
}

export function priorityBadge(priority) {
    const map = {
        low: 'bg-gray-100 text-gray-600',
        medium: 'bg-yellow-100 text-yellow-700',
        high: 'bg-red-100 text-red-700',
    };
    return map[priority] || 'bg-gray-100 text-gray-600';
}

// Only allow http/https product links. A wish.url authored by another user could
// otherwise be `javascript:...` (or `data:`), which React does NOT sanitize on an
// <a href>, so a gifter clicking "View product" would run it. Returns a safe href
// string or null (caller then hides the link).
export function safeHttpUrl(raw) {
    if (!raw || typeof raw !== 'string') return null;
    try {
        const u = new URL(raw, window.location.origin);
        return u.protocol === 'http:' || u.protocol === 'https:' ? u.href : null;
    } catch {
        return null;
    }
}
